// KW Heating & Cooling - Theme Constants
export const ROW_GUTTER = 16;
export const SIDE_NAV_WIDTH = 260;
export const SIDE_NAV_COLLAPSED_WIDTH = 80;
export const HEADER_HEIGHT = 70;
export const FOOTER_HEIGHT = 60;
export const TOP_NAV_HEIGHT = 55;
export const SIDE_NAV_LIGHT = 'SIDE_NAV_LIGHT';
export const SIDE_NAV_DARK = 'SIDE_NAV_DARK';
export const NAV_TYPE_SIDE = 'SIDE';
export const NAV_TYPE_TOP = 'TOP';
export const DIR_LTR = 'ltr';
export const DIR_RTL = 'rtl';
export const CONTENT_MAX_WIDTH = 1400;
export const CONTENT_HEIGHT_OFFSET = HEADER_HEIGHT + FOOTER_HEIGHT;
export const HEADER_BG_DEFAULT_COLOR_LIGHT = '#ffffff';
export const HEADER_BG_DEFAULT_COLOR_DARK = '#1a2744';
export const LAYOUT_CONTENT_GUTTER = 25;
export const LAYOUT_CONTENT_GUTTER_SM = 15;
export const SIDE_NAV_DARK_BG_COLOR = '#0f172a';

// KW Heating & Cooling - Brand Colors
export const BRAND_PRIMARY = '#2563EB'; // Main brand - trustworthy blue
export const BRAND_NAVY = '#1e3a5f';    // Secondary - Deep navy
export const BRAND_HEAT = '#F97316';    // Heating accent - warm orange
export const BRAND_HEAT_DEEP = '#EF4444'; // Heating deep - red
export const BRAND_COOL = '#06B6D4';    // Cooling accent - cyan
export const BRAND_TEAL = '#0d9488';    // Teal accent

// Primary Colors
export const BLUE_BASE = '#3b82f6';
export const PURPLE_BASE = '#8b5cf6';
export const CYAN_BASE = '#06b6d4';
export const GREEN_BASE = '#10b981';
export const MAGENTA_BASE = '#ec4899';
export const PINK_BASE = '#f472b6';
export const RED_BASE = '#ef4444';
export const ORANGE_BASE = '#F97316';
export const YELLOW_BASE = '#eab308';
export const VOLCANO_BASE = '#f97066';
export const GEEK_BLUE_BASE = '#3b82f6';
export const LIME_BASE = '#84cc16';
export const GOLD_BASE = '#F59E0B';

// Grayscale
export const WHITE = '#ffffff';
export const DARK = '#0f172a';
export const GRAY_DARK = '#1e293b';
export const GRAY = '#475569';
export const GRAY_LIGHT = '#94a3b8';
export const GRAY_LIGHTER = '#e2e8f0';
export const GRAY_LIGHTEST = '#f8fafc';

export const BODY_BACKGROUND = '#f1f5f9';

export const FONT_SIZE_BASE = 14;

export const TEMPLATE = {
    HEADER_HEIGHT,
    FOOTER_HEIGHT,
    CONTENT_HEIGHT_OFFSET,
    SIDE_NAV_WIDTH,
    SIDE_NAV_COLLAPSED_WIDTH,
    SIDE_NAV_DARK_BG_COLOR,
    CONTENT_MAX_WIDTH,
    HEADER_BG_DEFAULT_COLOR_LIGHT,
    HEADER_BG_DEFAULT_COLOR_DARK,
    LAYOUT_CONTENT_GUTTER,
    LAYOUT_CONTENT_GUTTER_SM,
    NAV_TYPE_SIDE,
    NAV_TYPE_TOP,
    SIDE_NAV_LIGHT,
    SIDE_NAV_DARK,
    DIR_LTR,
    DIR_RTL
}

export const THEME_COLOR = {
    BLUE: BLUE_BASE,
    PURPLE: PURPLE_BASE,
    CYAN: CYAN_BASE,
    GREEN: GREEN_BASE,
    MAGENTA: MAGENTA_BASE,
    PINK: PINK_BASE,
    RED: RED_BASE,
    ORANGE: ORANGE_BASE,
    YELLOW: YELLOW_BASE,
    VOLCANO: VOLCANO_BASE,
    GEEK_BLUE: GEEK_BLUE_BASE,
    LIME: LIME_BASE,
    GOLD: GOLD_BASE,
    // KW Heating & Cooling specific
    PRIMARY: BRAND_PRIMARY,
    NAVY: BRAND_NAVY,
    HEAT: BRAND_HEAT,
    COOL: BRAND_COOL,
}

export const FONT_WEIGHT = {
    LIGHTER: 'lighter',
    LIGHT: 300,
    NORMAL: 400,
    SEMIBOLD: 500,
    BOLD: 600,
    BASE: 400,
    BOLDER: 700
}

export const FONT_SIZES = {
    BASE: FONT_SIZE_BASE,
    LG: FONT_SIZE_BASE + 2,
    SM: 12
}

export const SPACER = {
    0: '0',
    1: '0.25rem',
    2: '0.5rem',
    3: '1rem',
    4: '1.5rem',
    5: '3rem',
}

const BREAKPOINT = {
    xs: '480px',
    sm: '576px',
    md: '768px',
    lg: '992px',
    xl: '1400px',
    xxl: '1600px'
}

export const MEDIA_QUERIES = {
    DESKTOP: `(min-width: ${BREAKPOINT.xl})`,
    LAPTOP: `(max-width: ${BREAKPOINT.xxl})`,
    LAPTOP_ABOVE: `(min-width: ${BREAKPOINT.xxl})`,
    TABLET: `(max-width: ${BREAKPOINT.lg})`,
    MOBILE: `(max-width: ${BREAKPOINT.md})`,
}

export const BORDER = {
    BASE_COLOR: '#e2e8f0'
}

export const GRAY_SCALE = {
    DARK,
    WHITE,
    GRAY_DARK,
    GRAY,
    GRAY_LIGHT,
    GRAY_LIGHTER,
    GRAY_LIGHTEST
}

export const DARK_MODE = {
    TEXT_COLOR: '#cbd5e1',
    HEADING_COLOR: '#f1f5f9',
    BG_COLOR: '#1e293b',
    BORDER_BASE_COLOR: '#334155',
    HOVER_BG_COLOR: '#334155',
    ACTIVE_BG_COLOR: '#1e3a5f',
    DROP_DOWN_SHADOW: '0 4px 6px -1px rgb(0 0 0 / 0.3), 0 2px 4px -2px rgb(0 0 0 / 0.3)'
}

// Shadows
export const SHADOWS = {
    SM: '0 1px 2px 0 rgb(0 0 0 / 0.05)',
    BASE: '0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1)',
    MD: '0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1)',
    LG: '0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1)',
    XL: '0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1)',
}

// Gradients
export const GRADIENTS = {
    PRIMARY: 'linear-gradient(135deg, #2563EB 0%, #1d4ed8 100%)',
    HEAT: 'linear-gradient(135deg, #F97316 0%, #EF4444 100%)',
    COOL: 'linear-gradient(135deg, #06B6D4 0%, #2563EB 100%)',
    NAVY: 'linear-gradient(135deg, #1e3a5f 0%, #0f172a 100%)',
    BLUE: 'linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%)',
    GREEN: 'linear-gradient(135deg, #10b981 0%, #059669 100%)',
    GOLD: 'linear-gradient(135deg, #F59E0B 0%, #d97706 100%)',
    PURPLE: 'linear-gradient(135deg, #8b5cf6 0%, #6d28d9 100%)',
}
